import { createContext, useContext } from 'react';
import { DataType } from '../types';

interface CanvasContextType {
  openMenu: (x: number, y: number, nodeId: string, handleId: string, type: DataType, isInput: boolean) => void;
  removeEdges: (edgeIds: string[]) => void;
}

export const CanvasContext = createContext<CanvasContextType | null>(null);

export const useCanvasContext = () => {
  const context = useContext(CanvasContext);
  if (!context) throw new Error("useCanvasContext must be used within a CanvasProvider");
  return context;
};